import { connect } from 'react-redux';
import { getVisibleBriefQuestions } from 'pap/utils';
import { getPapUrl, showAllQuestionsAtOnce } from 'pap_v2/utils';
import { PAPProgressBar } from 'pap/components/common/navigation';

const mapStateToProps = ({ pap }, { is1to1 }) => {
  const project = pap.project.projectData || {};
  const briefQuestions = getVisibleBriefQuestions(project, true);
  let links;

  if (!project.id || briefQuestions.length === 0) {
    links = {};
  } else {
    const reviewLink = getPapUrl({ step: 'review', projectId: project.id });

    if (is1to1) {
      links = {
        /* no link for 'Details' because there's no project at that point */
        brief: `/start-a-project/${project.id}/brief/${briefQuestions[0].name}/`,
        review: reviewLink
      };
    } else {
      links = {
        brief: getPapUrl({
          step: 'brief',
          projectId: project.id,
          subStep: showAllQuestionsAtOnce()? 'all' : briefQuestions[0].name
        }),
        details: getPapUrl({ step: 'details', projectId: project.id, subStep: 'package' }),
        review: reviewLink,
        payment: getPapUrl({ step: 'payment', projectId: project.id }),
      };
    }
  }

  return { links };
}

export default connect(mapStateToProps)(PAPProgressBar);



// WEBPACK FOOTER //
// ./pap/containers/common/progress_bar.js